import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Layout } from "./components/Layout";
import { useI18n } from "./i18n";
import { Landing } from "./pages/Landing";
import { Reserve } from "./pages/Reserve";
import { Manage } from "./pages/Manage";
import { Wall } from "./pages/Wall";
import { Wishes } from "./pages/Wishes";
import { Board } from "./pages/Board";
import { Admin } from "./pages/Admin";

function NotFound() {
  const { t } = useI18n();
  return (
    <div className="container-x py-24 text-center">
      <div className="text-6xl">🎂</div>
      <h1 className="section-title mt-4">404</h1>
      <Link to="/" className="btn-primary mt-6">
        {t("common.backHome")}
      </Link>
    </div>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout><Landing /></Layout>} />
        <Route path="/reserve" element={<Layout><Reserve /></Layout>} />
        <Route path="/manage/:token" element={<Layout><Manage /></Layout>} />
        <Route path="/wall" element={<Layout><Wall /></Layout>} />
        <Route path="/wishes" element={<Layout><Wishes /></Layout>} />
        <Route path="/board" element={<Board />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Layout><NotFound /></Layout>} />
      </Routes>
    </BrowserRouter>
  );
}
